import { BundleSaveDescriptor } from '../presentationSave.types';

/** Descriptor for bundle kinds whose content is entirely in their pages. */
export const noConfigBundleDescriptor: BundleSaveDescriptor = {
  ownedFields: [],
  canWrite: () => true,
  diffConfiguration: () => null,
};
